import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth, getAdmin, getEnterprise } from '../hooks/getAuth'
import Burger from './Burger'
import Menu from './Menu'
import { useRef } from 'react'
import { useOnClickOutside } from '../hooks/useOnClickOutside'
import { isMobile } from 'react-device-detect'
import { siteConfig } from '@/config/site'
import logo from '@/assets/images/hydra_score_head_sm.webp'
import { ETierKey } from '@/pages/subscribe/_data/subscribe-constant'
import { useQueryState } from 'nuqs'
import {
  TrialLimitType,
  TRIAL_LIMIT_QUERY_KEY,
} from './trial-modal/trial-limit-modal'

export default function Header({ localAuth, joyrideRun, setJoyrideRun }) {
  const isDemoUser =
    localAuth['sessionKey'] === 'a6cf9f6e-3341-4996-8d6a-83e826b67adf'
  const [_, setTrialLimitState] = useQueryState(TRIAL_LIMIT_QUERY_KEY)

  const location = useLocation()
  const navigate = useNavigate()
  const { setAuth, setIsLoggedIn, isLoggedIn, auth } = useAuth()
  const [burgerOn, setBurgerOn] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)
  const [isEnterpriseAdmin, setIsEnterpriseAdmin] = useState(false)
  const node = useRef()
  useOnClickOutside(node, () => setOpen(false))

  useEffect(() => {
    if (isLoggedIn) {
      setPageState('Profile')
      getAdmin(localAuth['sessionKey']).then((res) => {
        setIsAdmin(res)
      })
      getEnterprise(localAuth['sessionKey']).then((res) => {
        setIsEnterpriseAdmin(res)
      })
    } else {
      setPageState('Sign In')
    }
  }, [isLoggedIn])

  function handleResize() {
    if (window.innerWidth < 690) {
      setBurgerOn(true)
    } else {
      setBurgerOn(false)
    }
  }

  useEffect(() => {
    handleResize()
    const script = document.createElement('script')
    script.src = 'https://unpkg.com/maplibre-gl@latest/dist/maplibre-gl.js'
    script.async = true
    document.body.appendChild(script)
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const [pageState, setPageState] = useState('Sign In')
  const [open, setOpen] = useState(false)

  function pathMatchRoute(route) {
    if (route === location.pathname) {
      return true
    }
  }

  // Use this to hide the header
  if (
    location.pathname.includes('sign-in') ||
    location.pathname.includes('subscribe') ||
    location.pathname.includes('enterprise') ||
    location.pathname.includes('account-activation')
  ) {
    return null
  }

  const handleClickReport = () => {
    if (auth?.tier === ETierKey.Trial) {
      return setTrialLimitState(TrialLimitType.REPORTS_MENU_NOT_INCLUDED)
    }
    setJoyrideRun(false)
    navigate('/reports')
  }

  return (
    <div className="bg-white border-b shadow-sm sticky top-0 z-50">
      <header className="flex justify-between items-center px-3 min-h-[45px] max-w-6xl mx-auto">
        <div className="absolute left-10">
          <img
            src={logo}
            alt="logo"
            className="h-10 cursor-pointer"
            onClick={() => {
              setJoyrideRun(false)
              return navigate('/')
            }}
          />
        </div>
        <div></div>

        {burgerOn || isMobile ? (
          <div ref={node}>
            <Burger open={open} setOpen={setOpen} />
            <Menu
              isDemoUser={isDemoUser}
              isAdmin={isAdmin}
              isEnterpriseAdmin={isEnterpriseAdmin}
              open={open}
              setOpen={setOpen}
              pageState={pageState}
              navigate={navigate}
              setAuth={setAuth}
              setIsLoggedIn={setIsLoggedIn}
            />
          </div>
        ) : (
          <div>
            <ul className="flex space-x-10">
              <li
                className={`header-home cursor-pointer py-3 text-sm font-semibold  border-b-[3px]  ${
                  pathMatchRoute('/')
                    ? 'text-black border-b-red-500'
                    : 'text-gray-400 border-b-transparent'
                }`}
                onClick={() => {
                  setJoyrideRun(false)
                  return navigate('/')
                }}
              >
                Map
              </li>
              <li
                className={`header-portfolio cursor-pointer py-3 text-sm font-semibold  border-b-[3px]  ${
                  pathMatchRoute('/portfolio')
                    ? 'text-black border-b-red-500'
                    : 'text-gray-400 border-b-transparent'
                }`}
                onClick={() => {
                  setJoyrideRun(false)
                  return navigate('/portfolio')
                }}
              >
                Portfolio
              </li>
              <li
                className={`header-reports cursor-pointer py-3 text-sm font-semibold  border-b-[3px]  ${
                  pathMatchRoute('/reports')
                    ? 'text-black border-b-red-500'
                    : 'text-gray-400 border-b-transparent'
                }`}
                onClick={handleClickReport}
              >
                Reports
              </li>
              <li
                className={`header-profile cursor-pointer py-3 text-sm font-semibold  border-b-[3px]  ${
                  pathMatchRoute('/sign-in') || pathMatchRoute('/profile')
                    ? 'text-black border-b-red-500'
                    : 'text-gray-400 border-b-transparent'
                }`}
                onClick={() => {
                  setJoyrideRun(false)
                  return navigate('/profile')
                }}
              >
                {pageState}
              </li>
              {isDemoUser && (
                <li
                  className={`header-exit-demo cursor-pointer flex justify-center items-center w-[100px] h-[40px] my-auto text-sm font-semibold bg-[#2c2c2c] text-white rounded-[25px] hover:bg-[#494949]`}
                  onClick={() => {
                    localStorage.setItem('auth', JSON.stringify({}))
                    setAuth(null)
                    setIsLoggedIn(false)
                    window.location.href = siteConfig.landingUrl
                  }}
                >
                  Exit Demo
                </li>
              )}
              {isAdmin && (
                <li
                  className={`header-admin cursor-pointer py-3 text-sm font-semibold  border-b-[3px]  ${
                    pathMatchRoute('/admin')
                      ? 'text-black border-b-red-500'
                      : 'text-gray-400 border-b-transparent'
                  }`}
                  onClick={() => {
                    setJoyrideRun(false)
                    return navigate('/admin')
                  }}
                >
                  Admin
                </li>
              )}
              {isEnterpriseAdmin && (
                <li
                  className={`header-admin cursor-pointer py-3 text-sm font-semibold  border-b-[3px]  ${
                    pathMatchRoute('/enterprise')
                      ? 'text-black border-b-red-500'
                      : 'text-gray-400 border-b-transparent'
                  }`}
                  onClick={() => {
                    setJoyrideRun(false)
                    return navigate('/enterprise')
                  }}
                >
                  Enterprise Admin
                </li>
              )}
            </ul>
          </div>
        )}
        {/* {burgerOn && } */}
      </header>
    </div>
  )
}
